import React from "react";
import {Typography} from "antd";

export default ({children, small}) => {
    return (
        <Typography.Text type={'secondary'}>{small ? <small>{children}</small> : children}</Typography.Text>
    )
}